import React from "react";

const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="relative bg-cream border-t border-ink-900/10 pt-20 pb-10"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-12 gap-8">
                    <div className="col-span-12 lg:col-span-10">
                        <h3 className="font-display text-3xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-ink-900">
                            <em className="text-bisleri">"</em>People from slum areas and the poor
                            can get treated as they hardly have to pay anything.<em className="text-bisleri">"</em>
                        </h3>
                        <div className="mt-6 eyebrow">— Dr. Rahul Ghule, Hindustan Times</div>
                    </div>
                </div>

                <div className="mt-20 grid grid-cols-12 gap-8 items-end pt-10 border-t border-ink-900/10">
                    <div className="col-span-12 md:col-span-4">
                        <div className="font-display italic text-2xl text-ink-900">
                            Dr. Rahul Ghule <span className="text-bisleri not-italic">/ MBBS</span>
                        </div>
                        <div className="mt-2 eyebrow text-ink-500">
                            MBBS, KEM Mumbai · CEO &amp; Founder, Magicdil Group
                        </div>
                    </div>

                    <div className="col-span-12 md:col-span-4">
                        <div className="eyebrow mb-3">Ventures</div>
                        <div className="font-body text-sm text-ink-700 space-y-1">
                            <div>One Rupee Clinic</div>
                            <div>Kamal Pharma · Kamal Pathology Lab</div>
                            <div>Kamal Hospital · CT Scan · Ambulance</div>
                            <div>Swasthyamrut Ayurvedic Centre</div>
                        </div>
                    </div>

                    <div className="col-span-12 md:col-span-4 md:text-right">
                        <div className="eyebrow mb-3">Site</div>
                        <div className="font-body text-sm text-ink-700 space-y-1">
                            <div>© {new Date().getFullYear()} Dr. Rahul Ghule</div>
                            <div>All photographs are property of the office.</div>
                            <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-ink-500 mt-3">
                                Mumbai · India
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
